import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

// Custom Reducers.
import error from 'reducers/error';
import lmsMaterial from 'reducers/lmsMaterial';

const createRootReducer = (history) =>
 combineReducers({
  router: connectRouter(history),
  error,
  lmsMaterial,
});

export default createRootReducer;
